import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { color, ColorManipulationViewModel } from "./colorManipulation-viewModel"

export class ColorManipulationView extends View<ColorManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-F1D7DA48-33D5-48EC-8A94-858E1BA32D20"
    }
    loadHtml(): string {
        let element = require('./colorManipulation.html').default;
        let style = require('./colorManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set colors(v: ObservableArray<color>) { this._colors = v; } public get colors(): ObservableArray<color> { return this._colors;} private _colors: ObservableArray<color>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    requestColorCreation(){
        this.dataContext.requestColorCreation();
    }
}
